<template>
  <div id="app">

    <router-view></router-view>
  </div>
</template>

<script>
	sessionStorage.clear();
    export default{
        name: 'App',
        methods: {
            created () {
                console.log("app")
            }
        }
    }
</script>

<style lang="scss">
	@import './styles/base.css';
	.questionbox{
		.el-input__inner{border-radius: 0.08*25px;border: 0.03*25px solid #ddd;}
		.el-radio-group{
		    display: block;
			.el-radio{display:block;line-height: 0.99*25px;background: #FFFFFF;border-radius: 0.08*25px;border: 0.03*25px solid #ddd;margin-bottom:0.3*25px;text-align: left;font-size: 0.38*25px;color: #272727;}
		    .el-radio__input.is-checked+.el-radio__label{color:#272727;}
		    .el-radio__inner{border: 0.03*25px solid #272727;}
		    .el-radio__input{float:right;margin:0.32*20px 0.32*20px 0 0;}
		    .el-radio__input.is-checked .el-radio__inner{border-color: #2FAF36;background: #2FAF36;}
		    .el-input{margin-bottom:0.3*25px;}
		}
		.el-checkbox-group{
		    display: block;
			.el-checkbox{display:block;line-height: 0.99*25px;background: #FFFFFF;border-radius: 0.08*25px;border: 0.03*25px solid #ddd;margin-bottom:0.3*25px;text-align: left;font-size: 0.38*25px;color: #272727;padding-left:0.21333*25px;}
			.el-checkbox.is-checked{
				// background: #2FAF36;border-color:#2FAF36;
				}
			.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: #2FAF36;border-color: #2FAF36;}
			.el-checkbox__input.is-checked+.el-checkbox__label{
				color:#2FAF36;
				}
			.el-checkbox__input{
				// display:none;
				}
		    .el-input{margin-bottom:0.3*25px;}
		}
		.el-radio__label {
		    white-space: normal;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue